import React, { useEffect, useState } from 'react';

import api from '../../api/axios';

const ByKam = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/admin/tickets/by-kam')
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="w-full px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Tickets by KAM</h1>
          <p className="text-gray-500 text-sm">KAM-wise ticket breakdown</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          {loading ? (
            <div className="text-center py-8 text-gray-400">Loading...</div>
          ) : (
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  {['KAM ID', 'KAM Name', 'Total', 'Open', 'Resolved'].map(h => (
                    <th key={h} className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {data.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm text-gray-500">{row.kamId}</td>
                    <td className="px-6 py-4 text-sm font-medium text-gray-800">{row.kamName}</td>
                    <td className="px-6 py-4 text-sm font-bold text-gray-700">{String(row.total)}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-amber-600">{String(row.open)}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-green-600">{String(row.resolved)}</td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr><td colSpan={5} className="text-center py-8 text-gray-400">No data available</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ByKam;
